import { Box, Typography, Icon, styled, visuallyHidden } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';

const ColoredText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'IsActive' && prop !== 'isComplete',
})(({ theme, isActive, isComplete }) => {
  if (isActive) {
    return { color: theme.palette.blue.main, fontWeight: 'bold' };
  }
  if (isComplete) {
    return { color: theme.palette.text.disabled };
  }
  return { color: theme.palette.grey.dark };
});

const StyledCircle = styled(Box, {
  shouldForwardProp: prop => prop !== 'IsActive' && prop !== 'isComplete',
})(({ theme, isActive, isComplete }) => {
  let background = theme.palette.common.white;
  let color = theme.palette.blue.main;
  if (isComplete) {
    background = theme.palette.background.main;
    color = theme.palette.blue.main;
  }
  if (isActive) {
    background = theme.palette.blue.main;
    color = theme.palette.common.white;
  }
  return {
    background,
    color,
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    fontWeight: 600,
    boxShadow: theme.shadows[4],
    flex: 'none',
  };
});

const Step = ({ isActive, isComplete, title, index }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center">
      <StyledCircle mr={2} isActive={isActive} isComplete={isComplete}>
        {isComplete ? (
          <Icon iconName="check" />
        ) : (
          <>
            <span style={visuallyHidden}>{t('components.step', { step: index + 1 })}</span>
            <span aria-hidden>{index + 1}</span>
          </>
        )}
      </StyledCircle>
      <ColoredText component="span" isActive={isActive} isComplete={isComplete}>
        {title}
      </ColoredText>
    </Box>
  );
};

export default Step;
